import { ComponentType } from '../component/component-types'

export enum ReportExportType {
    HistoricalAnalysis = 1, // Used for both Transformer Oil Analysis and Generator Historical Analyses
    TransformerOilAnalysisStatus = 2,
    SummaryConditionStatus = 5, // Used for both Transformer and Generator Summary Condition Status
}

// Legacy names for backward compatibility
export const OilAnalysisData = ReportExportType.HistoricalAnalysis
export const OilAnalysisStatus = ReportExportType.TransformerOilAnalysisStatus
export const SummaryComponentConditionStatus = ReportExportType.SummaryConditionStatus

type ReportTypeConfig = {
    labelKey: string
    value: ReportExportType
}

// Mapping of Component Types to their available Report Types
export const ComponentTypeToReportTypes: Record<ComponentType, ReportTypeConfig[]> = {
    [ComponentType.Transformer]: [
        {
            labelKey: 'reports.export.reportTypes.transformerHistoricalOilAnalysis',
            value: ReportExportType.HistoricalAnalysis,
        },
        {
            labelKey: 'reports.export.reportTypes.transformerOilAnalysisStatus',
            value: ReportExportType.TransformerOilAnalysisStatus,
        },
        {
            labelKey: 'reports.export.reportTypes.summaryTransformerConditionStatus',
            value: ReportExportType.SummaryConditionStatus,
        },
    ],
    [ComponentType.Generator]: [
        {
            labelKey: 'reports.export.reportTypes.generatorHistoricalAnalyses',
            value: ReportExportType.HistoricalAnalysis,
        },
        {
            labelKey: 'reports.export.reportTypes.summaryGeneratorConditionStatus',
            value: ReportExportType.SummaryConditionStatus,
        },
    ],
    [ComponentType.Turbine]: [],
}

// All export types (for backward compatibility if needed)
export const ReportExportTypes = [
    {
        labelKey: 'reports.export.reportTypes.transformerHistoricalOilAnalysis',
        value: ReportExportType.HistoricalAnalysis,
    },
    {
        labelKey: 'reports.export.reportTypes.transformerOilAnalysisStatus',
        value: ReportExportType.TransformerOilAnalysisStatus,
    },
    {
        labelKey: 'reports.export.reportTypes.generatorHistoricalAnalyses',
        value: ReportExportType.HistoricalAnalysis,
    },
    {
        labelKey: 'reports.export.reportTypes.summaryTransformerConditionStatus',
        value: ReportExportType.SummaryConditionStatus,
    },
    {
        labelKey: 'reports.export.reportTypes.summaryGeneratorConditionStatus',
        value: ReportExportType.SummaryConditionStatus,
    },
] as const

export const AllGroupsOptionExceptionForExportType = {
    includeAllGroupsOption: [
        ReportExportType.TransformerOilAnalysisStatus,
        ReportExportType.SummaryConditionStatus,
    ],
}
